export default {
    created: "Destinatarul campaniei WhatsApp a fost creat cu succes.",
    updated: "Destinatarul campaniei WhatsApp a fost actualizat cu succes.",
    deleted: "Destinatarul campaniei WhatsApp a fost sters cu succes.",
    restored: "Destinatarul campaniei WhatsApp a fost restaurat cu succes.",
    export: "Exportul a fost inceput cu succes.",
}
